import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import { CommonToolTip, CstmPagination } from "components/Common/Common";
import { Link, useNavigate } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { successMessageToast } from "helpers/common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import ErrorComponent from "components/shared/ErrorComponent";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { useRolesLookupQuery } from "store/services/utility";
import { CHATTER_PEER_EDIT, MANAGE_PARENTS_EDIT, MANAGE_SUPPORT_STAFF_EDIT, MANAGE_TEACHERS_EDIT, MANAGE_USERS_ADD, MANAGE_USERS_EDIT, MANAGE_USERS_VIEW, THERAPIST_EDIT } from "config/paths";
import { useGetUsersWithRoleQuery, useResendAdminAccountActivationMailMutation, useUpdateSubAdminAccountStatusMutation, useUpdateSubAdminLoginStatusMutation, useVerifySubAdminEmailMutation } from "store/services/users/role";
import { ChatIcon, EditIcon, PermissionIcon, VerifyIcon } from "Assets/icons";
import AlertPop from "components/Modals/AlertPop";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { useDispatch, useSelector } from "react-redux";
import { usersFilter } from "store/slices/filter";
import { SUB_ADMIN_LOGIN_STATUS_OPTIONS, SUB_ADMIN_STATUS_OPTIONS } from "config/constants";

const ManageSubAdmin = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const filter = useSelector(state => state?.filter?.usersFilter);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [showModal, setShowModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showActivateAccountModal, setShowActivateAccountModal] = useState(false);

    // Roles
    const { data: roles, isLoading: getRolesLoading } = useRolesLookupQuery();

    const { data, isLoading, isError, isFetching } = useGetUsersWithRoleQuery({ page: currentPage, limit: pageSize, ...filter });
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    // Activation mail
    const [resendAccountActivation, { isLoading: resendMailLoading }] = useResendAdminAccountActivationMailMutation();

    // update account status
    const [updateAccountStatus, { isLoading: updateAccountStatusLoading }] = useUpdateSubAdminAccountStatusMutation();

    // update login status
    const [updateLoginStatus, { isLoading: updateLoginStatusLoading }] = useUpdateSubAdminLoginStatusMutation();

    // Verify Account
    const [verifyAccount, { isLoading: verifyAccountLoading }] = useVerifySubAdminEmailMutation();

    const handleEditClick = (item) => {
        let path = null;

        switch (item?.client_role?.slug) {
            case "parent": path = MANAGE_PARENTS_EDIT.replace(":id", item?.id);
                break;
            case "peer": path = CHATTER_PEER_EDIT.replace(":id", item?.id);
                break;
            case "sub_admin": path = MANAGE_USERS_EDIT.replace(":id", item?.id);
                break;
            case "support_staff": path = MANAGE_SUPPORT_STAFF_EDIT.replace(":id", item?.id);
                break;
            case "teacher": path = MANAGE_TEACHERS_EDIT.replace(":id", item?.id);
                break;
            case "therapist": path = THERAPIST_EDIT.replace(":id", item?.id);
                break;

            default: path = null;
                break;
        };
        console.log("path", item)

        path && navigate(path);
    };

    const column = [
        {
            head: "Last Name",
            accessor: "lastname",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.lastname || "--"}</h6>
            ),
        },
        {
            head: "First Name",
            accessor: "firstname",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.firstname || "--"}</h6>
            ),
        },
        {
            head: "Phone Number",
            accessor: "phone",
            component: (item, ind) => (
                <p>{item?.phone || "--"}</p>
            ),
        },
        {
            head: "Email",
            accessor: "email",
            isComponent: true,
            component: (item, ind) => (
                <p className="cell-text-ellipsis">{item?.email || "--"}</p>
            ),
        },
        {
            head: "Role",
            accessor: "role",
            isComponent: true,
            component: (item, ind) => (
                <>{item?.client_role?.title || "--"}</>
            ),
        },
        {
            head: "Status",
            accessor: "status",
            isComponent: true,
            component: (item) => (
                <Dropdown
                    onSelect={(value) => {
                        setCurrentEntry({ type: "status", userId: item?.id, status: value })
                        setShowUpdateModal(true);
                    }}
                >
                    <Dropdown.Toggle
                        disabled={isFetching || updateAccountStatusLoading}
                        variant="transparent"
                        className="border d-flex align-items-center  justify-content-between"
                        id="dropdown-basic"
                        style={{ minWidth: "100px" }}
                    >

                        {SUB_ADMIN_STATUS_OPTIONS?.find(x => x.value == item?.status)?.label || "Status"}                                                        <span className="icn ms-2">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                            >
                                <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                />
                            </svg>
                        </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu >
                        {
                            SUB_ADMIN_STATUS_OPTIONS?.map((item, index) => {
                                if (item.value) return <Dropdown.Item key={index} eventKey={item?.value}>{item?.label}</Dropdown.Item>
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            ),
        },
        {
            head: "Login Status",
            accessor: "isLoginAllowed",
            isComponent: true,
            component: (item) => (
                <Dropdown
                    onSelect={(value) => {
                        setCurrentEntry({ type: "loginStatus", userId: item?.id, status: value })
                        setShowUpdateModal(true);
                    }}
                >
                    <Dropdown.Toggle
                        disabled={isFetching || updateLoginStatusLoading}
                        variant="transparent"
                        className="border d-flex align-items-center  justify-content-between"
                        id="dropdown-basic"
                        style={{ minWidth: "100px" }}
                    >

                        {SUB_ADMIN_LOGIN_STATUS_OPTIONS?.find(x => x.value == item?.isLoginAllowed)?.label || "Login Status"}                                                        <span className="icn ms-2">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                            >
                                <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                />
                            </svg>
                        </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu >
                        {
                            SUB_ADMIN_LOGIN_STATUS_OPTIONS?.map((item, index) => {
                                return <Dropdown.Item key={index} eventKey={item?.value}>{item?.label}</Dropdown.Item>
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    {Boolean(item?.client_role?.slug) && <CommonToolTip
                        text={"Edit"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={() => handleEditClick(item)}
                        >
                            <EditIcon />
                        </Button>}
                    />}
                    <CommonToolTip
                        text={"Resend Mail"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation()

                                if (item?.email_verified_at) {

                                    setShowAlertModal(true);
                                    return;
                                };
                                setCurrentEntry(item);
                                setShowModal(true);
                            }}
                        >
                            <ChatIcon />
                        </Button>}
                    />
                    <CommonToolTip
                        text={"Permissions"}
                        component={
                            <Button
                                className="p-0"
                                variant="transparent"
                                type="button"
                                onClick={() => navigate(MANAGE_USERS_VIEW?.replace(':id', item?.id))}
                            >
                                <PermissionIcon />
                            </Button>}
                    />
                    {!item?.email_verified_at && <CommonToolTip
                        text={"Verify Account"}
                        component={
                            <Button
                                className="p-0"
                                variant="transparent"
                                type="button"
                                onClick={() => {
                                    setCurrentEntry(item);
                                    setShowActivateAccountModal(true);
                                }}
                            >
                                <VerifyIcon />
                            </Button>}
                    />}
                </div>
            ),
        },
    ]

    const handleFilterChange = (key) => (value) => {
        dispatch(usersFilter({ ...filter, [key]: value }))
        setCurrentPage(1);
    }

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const resetFilter = () => {
        dispatch(usersFilter({ search: "", role: 2, status: "active", sort: { column: "lastname", direction: "asc" } }));
        setCurrentPage(1)
    };

    const handleResendMail = async () => {
        try {

            setShowModal(false);

            let result = await resendAccountActivation(currentEntry?.id);
            if (!result.error) {
                successMessageToast("Account activation mail has been sent successfully.");
            }
        } catch (err) {
            console.log("error resend activation mail", err);
        }
    };

    const handleStatusUpdate = async () => {
        try {

            setShowUpdateModal(false);
            const result = currentEntry?.type == "status" ? await updateAccountStatus(currentEntry) : currentEntry?.type == "loginStatus" ? await updateLoginStatus(currentEntry) : { error: "" };
            if (result?.error) return;

            successMessageToast(result?.data?.message);
        } catch (err) { console.log("error update status", err); }
    };

    const handleVerifyAccount = async () => {
        try {

            setShowActivateAccountModal(false);
            const result = await verifyAccount(currentEntry?.id);
            if (result?.error) return;

            successMessageToast(result?.data?.message);
        } catch (err) { console.log("error activating account", err); }
    };

    return (
        <>
            <AlertPop
                confirmation={showAlertModal}
                setConfirmation={setShowAlertModal}
                message={"The account has been already verified"}
            />

            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={handleResendMail}
                type="resendAccountActivationMail"
            />

            <ConfirmationPop
                confirmation={showUpdateModal}
                setConfirmation={setShowUpdateModal}
                confirmHandler={handleStatusUpdate}
                type="update"
            />

            <ConfirmationPop
                confirmation={showActivateAccountModal}
                setConfirmation={setShowActivateAccountModal}
                confirmHandler={handleVerifyAccount}
                type="verifyAccount"
            />

            <section className="ManageDiscriplines position-relative py-4">
                <Container fluid={true}>
                    <Row>
                        <Col lg="12" className="my-2">
                            <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                <div className="left">
                                    <TableHeader
                                        hideStatusFilter
                                        heading={"Admin Users"}
                                        handleFilterChange={handleFilterChange}
                                        resetFilter={resetFilter}
                                        filter={filter}
                                        searchPlaceholder="Email, First, Last Name"
                                        filterComponent={
                                            <>
                                                <li>
                                                    <Dropdown onSelect={handleFilterChange("role")}>
                                                        <Dropdown.Toggle
                                                            variant="transparent"
                                                            className="border-0 d-flex align-items-center  justify-content-between"
                                                            id="dropdown-basic"
                                                            style={{ minWidth: "150px" }}
                                                        >

                                                            {roles?.find(x => x.id == filter?.role)?.title || "Select Role"}                                                        <span className="icn ms-2">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="12"
                                                                    height="8"
                                                                    viewBox="0 0 12 8"
                                                                    fill="none"
                                                                >
                                                                    <path
                                                                        d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                                        fill="black"
                                                                    />
                                                                </svg>
                                                            </span>
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu >
                                                            {
                                                                roles?.map((item, index) => {
                                                                    if (![3, 7].includes(item.id)) return <Dropdown.Item key={index} eventKey={item?.id}>{item?.title}</Dropdown.Item>
                                                                })
                                                            }
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </li>
                                                <li>
                                                    <Dropdown onSelect={handleFilterChange("status")}>
                                                        <Dropdown.Toggle
                                                            variant="transparent"
                                                            className="border-0 d-flex align-items-center  justify-content-between"
                                                            id="dropdown-basic"
                                                            style={{ minWidth: "150px" }}
                                                        >

                                                            {SUB_ADMIN_STATUS_OPTIONS?.find(x => x.value && x.value == filter?.status)?.label || "Status"}                                                        <span className="icn ms-2">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="12"
                                                                    height="8"
                                                                    viewBox="0 0 12 8"
                                                                    fill="none"
                                                                >
                                                                    <path
                                                                        d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                                        fill="black"
                                                                    />
                                                                </svg>
                                                            </span>
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu >
                                                            {
                                                                SUB_ADMIN_STATUS_OPTIONS?.map((item, index) => {
                                                                    return <Dropdown.Item key={index} eventKey={item?.value}>{item?.label}</Dropdown.Item>
                                                                })
                                                            }
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </li>
                                            </>
                                        }
                                    />
                                </div>
                                <div className="right">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                        <li className="">
                                            <Link
                                                to={MANAGE_USERS_ADD}
                                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                            >
                                                <span className="icn me-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="19"
                                                        height="19"
                                                        viewBox="0 0 19 19"
                                                        fill="none"
                                                    >
                                                        <mask
                                                            id="mask0_0_4440"
                                                            style={{ maskType: "alpha" }}
                                                            maskUnits="userSpaceOnUse"
                                                            x="0"
                                                            y="0"
                                                            width="19"
                                                            height="19"
                                                        >
                                                            <rect
                                                                width="18.7197"
                                                                height="18.7197"
                                                                fill="#D9D9D9"
                                                            />
                                                        </mask>
                                                        <g mask="url(#mask0_0_4440)">
                                                            <path
                                                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                                                fill="white"
                                                            />
                                                        </g>
                                                    </svg>
                                                </span>{" "}
                                                Add Sub Admin
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="table-outer">
                                {isLoading || getRolesLoading ? (
                                    <div style={{ height: "200px" }}>
                                        <LoadingIndicator />
                                    </div>
                                ) : isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(isFetching || resendMailLoading || updateAccountStatusLoading || updateLoginStatusLoading || verifyAccountLoading) && (
                                            <LoadingOverlay />
                                        )}
                                        <TableLayout
                                            data={data?.records || []}
                                            column={column}
                                            filter={filter}
                                        />
                                    </>
                                )}
                                <CstmPagination
                                    totalPages={totalPages}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ManageSubAdmin;
